'use strict';

// If changing, align with constants.py
module.exports = {
  categorical: 'categorical',
  powerLaw: 'powerLaw',
  linear: 'linear',
};
